import { render, staticRenderFns } from "./certificateDialog.vue?vue&type=template&id=121a7fd2&scoped=true&"
import script from "./certificateDialog.vue?vue&type=script&lang=js&"
export * from "./certificateDialog.vue?vue&type=script&lang=js&"
import style0 from "./certificateDialog.vue?vue&type=style&index=0&id=121a7fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121a7fd2",
  null
  
)

export default component.exports